import { Button, Card, Modal, Table } from "antd";
import React, { useEffect, useState } from "react";
import { ActivityData } from "../../../Data/AllactivityJson";
import SearchBox from "../../../components/SearchBox";
import { Link, useLocation, useParams } from "react-router-dom";
import { Api_Url } from "../../../config/config";
import axios from "axios";
import { Applogo } from "../../../Routes/ImagePath";
import moment from "moment";
import { ErrorToast, SuccessToast } from "../../ToastComponent";

function MyActivitiesPage() {
  const location = useLocation();
  const { state } = location;
  console.log("lll", state?.id);
  // const {  } = state || {};

  const { id } = useParams();

  const [singleData, setSingleData] = useState([]);
  // const [isOnline, setIsOInline] = useState(false)
  const [alldata, setALlData] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);

  const MyTeamsAllActivityFunc = async () => {
    try {
      const managerId = JSON.parse(sessionStorage.getItem("user"))?.id;
      const response = await axios.get(
        `${Api_Url}api/v1/Team/${managerId}/team-members/${id}`,
        {
          headers: {
            Authorization: `Bearer ${
              JSON.parse(sessionStorage.getItem("user")).accessToken
            }`,
          },
        }
      );
      // console.log("data", response.data.data)
      setSingleData(response.data.data);
    } catch (error) {
      return error.message;
    }
  };

  useEffect(() => {
    MyTeamsAllActivityFunc();
  }, []);

  const [data, setData] = useState([]);

  //Users Activity Api

  const UserActivityDataFetch = async () => {
    try {
      const userId = JSON.parse(sessionStorage.getItem("user"))?.id;
      const response = await axios.get(
        `${Api_Url}api/v1/UserActivity/${userId}`,
        {
          headers: {
            Authorization: `Bearer ${
              JSON.parse(sessionStorage.getItem("user")).accessToken
            }`,
          },
        }
      );
      // console.log("response", response.data)
      setData(response.data);
    } catch (error) {
      return error.message;
    }
  };

  useEffect(() => {
    UserActivityDataFetch();
  }, []);

  const [AllActivity, setAllActivity] = useState([]);
  const [AllActivityDataCount, setAllActivityDataCount] = useState([]);
  const [allData, setAllData] = useState([]);

  const handleAllActivity = async () => {
    try {
      const teamMemberId = state.id;
      const response = await axios.get(
        `${Api_Url}api/v1/ActivityLog/myself?UserId=${teamMemberId}`,
        {
          headers: {
            Authorization: `Bearer ${
              JSON.parse(sessionStorage.getItem("user")).accessToken
            }`,
          },
        }
      );
      console.log("hh", response.data?.data);
      setAllActivityDataCount(response.data?.data?.activityCount);
      setAllActivity(response.data?.data?.activityList);
      setAllData(response.data?.data);
    } catch (error) {
      return error.message;
    }
  };

  useEffect(() => {
    handleAllActivity();
  }, []);

  console.log("momoo", allData);

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
    },
    {
      title: "Description",
      dataIndex: "description",
    },
    {
      title: "Activity Date",
      dataIndex: "",
      render: (text, record) => (
        <span className="table-avatar">
          {moment(text.activityDate).format("MMMM Do YYYY, h:mm:ss a")}
        </span>
      ),
    },
    {
      title: "View",
      dataIndex: "actions",
      render: (text, record) => (
        <Button
          className="btn-property"
          onClick={() => handleViewClick(record)}
        >
          <i className="fa-solid fa-eye"></i>
        </Button>
      ),
    },
  ];

  const handleViewClick = async (record) => {
    console.log(record);

    const urlMap = {
      1: "CollectionVisit",
      2: "AuthorityVisit",
      3: "PropertyVisit",
      4: "BrokerVisit",
      5: "DeskWork",
      6: "Lead",
      7: "FileLogin",
      8: "CollectingIMD",
      9: "OTCClearance",
      10: "EMICollection",
      11: "ChannelPartner",
      12: "MarketingActivity",
      13: "VendorVisit",
      14: "BusinessPd",
      15: "ResidencePd",
      16: "CollectingDocument",
      17: "BankVisit",
      18: "CustomerVisit",
      19: "BTBankVisit",
      20: "LeadGeneration",
      21: "BrandVisibility",
      22: "ActivityToRecruit",
      23: "DutyOn",
      24: "DutyOff",
    };

    const endpoint = urlMap[record.activityId];

    if (endpoint) {
      try {
        const response = await axios.get(
          `${Api_Url}api/v1/${endpoint}/${record.tableId}`,
          {
            headers: {
              Authorization: `Bearer ${
                JSON.parse(sessionStorage.getItem("user")).accessToken
              }`,
            },
          }
        );
        console.log(response.data.data);
        setALlData(response?.data?.data);
        setIsModalVisible(true);
      } catch (error) {
        console.error(error);
      }
    } else {
      console.log(`No handler for activityId ${record.activityId}`);
    }
  };

  const handleDowload = async () => {
    try {
      const response = await axios.get(
        `${Api_Url}api/v1/ActivityLog/download/excel/myself?UserId=${state?.id}`,
        {
          responseType: "blob", // Important to handle binary data correctly
          headers: {
            Authorization: `Bearer ${
              JSON.parse(sessionStorage.getItem("user"))?.accessToken
            }`,
          },
        }
      );

      // Create a blob object from the response
      const file = new Blob([response.data], { type: "application/pdf" });

      // Create a URL for the blob object
      const fileURL = URL.createObjectURL(file);

      // Create a link element
      const link = document.createElement("a");
      link.href = fileURL;
      link.setAttribute("download", `ActivityLog-${id}.xlsx`); // Specify the file name

      // Append the link to the body
      document.body.appendChild(link);

      // Trigger the download
      link.click();

      // Clean up
      URL.revokeObjectURL(fileURL);
      document.body.removeChild(link);

      SuccessToast("Download Successful");
    } catch (error) {
      ErrorToast("Something went wrong");
    }
  };

  return (
    <div className="page-wrapper">
      <div className="content container-fluid">
        <div class="card">
          <div className="card-body">
            {/* Wrap the content in a flex container */}
            <div className="d-flex align-items-center justify-content-between mb-2">
              <div className="d-flex align-items-center">
                <img
                  style={{ height: "40px", width: "60px" }}
                  src={singleData.imageUrl}
                  alt="User"
                  className="me-3" // margin-end to add space between image and name
                />
                <div>
                  <h5 className="mb-1">
                    {singleData.firstName} {singleData.lastName}
                  </h5>
                  <p className="card-text mb-1">
                    {state.isOnline ? (
                      <span className="text-success">Online</span>
                    ) : (
                      <span className="text-danger">Offline</span>
                    )}
                  </p>
                </div>
              </div>
              {/* Download Button */}
              <Button type="primary" onClick={handleDowload}>
                Download
              </Button>
            </div>

            <h6 className="card-subtitle mb-2 text-muted">
              {singleData.designation}
            </h6>
            <p className="card-text">Department: {singleData.department}</p>
          </div>
        </div>
        {AllActivityDataCount && AllActivityDataCount.length > 0 ? (
          <>
            <div className="row">
              <div className="col-md-12">
                <div className="table-responsive">
                  <div className="container">
                    <div className="row">
                      {AllActivityDataCount &&
                        AllActivityDataCount.length > 0 &&
                        AllActivityDataCount.map((item) => {
                          return (
                            <>
                              <div className="col-md-2">
                                <div class="profile-widget">
                                  <div class="">
                                    <a class="avatar" href="/profile">
                                      <h2>{item.count}</h2>
                                    </a>
                                  </div>
                                  <h4 class="user-name m-t-10 mb-0 text-ellipsis">
                                    <a href="/profile/1">{item?.name}</a>
                                  </h4>
                                </div>
                              </div>
                            </>
                          );
                        })}
                    </div>
                  </div>

                  {/* <SearchBox /> */}
                  <Table
                    className="table-striped"
                    style={{ overflowX: "auto" }}
                    columns={columns}
                    dataSource={AllActivity}
                    rowKey={(record) => record.id}
                  />
                </div>
              </div>
            </div>
          </>
        ) : (
          <p>No Data Found</p>
        )}


        <Modal
          title="Activity Details"
          visible={isModalVisible}
          onCancel={() => setIsModalVisible(false)}
          footer={null}
          className="custom-modal" // Add custom class for additional styling if needed
        >
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="card">
                  <div className="card-body d-flex align-items-center">
                    {alldata?.selfieUrl && (
                      <div className="selfie-container me-3">
                        <img
                          src={alldata.selfieUrl}
                          alt="Selfie"
                          style={{
                            width: "60px",
                            height: "60px",
                            borderRadius: "50%",
                          }}
                        />
                      </div>
                    )}
                    <div>
                      <h1 className="card-title">
                        {alldata?.firstName} {alldata?.lastName} {alldata?.name}
                      </h1>
                      <p className="card-text mb-1">
                        {alldata?.mobile ? `Mobile No: ${alldata?.mobile}` : ""}
                      </p>
                      <p className="card-text">
                        {alldata?.created
                          ? `Created At: ${moment(alldata?.created).format(
                              "MMMM Do YYYY, h:mm:ss a"
                            )}`
                          : "Creation date not available"}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    </div>
  );
}

export default MyActivitiesPage;
